module.exports = __webpack_public_path__ + "img/18_maska_serdce.cd9daef.svg";